import React, { Component } from 'react';
import PropTypes from 'prop-types';

import shapes from './shapes';

/**
 * Renders NotificationEmpty data.
 *
 * @class NotificationEmpty
 * @public
 *
 * @returns {React.ReactElement} NotificationsEmpty component
 */

class NotificationsEmpty extends Component {
  render() {
    const { error } = this.props;

    if (error) {
      const {
        sso,

        messages: {
          failedNotificationsTitle,
          failedNotificationsText,
          failedNotificationsLink,
          notificationsError
        }
      } = this.props;
      const classes = 'notifications-list-empty notifications-session-alert';
      let errorContent = <div>{ notificationsError }</div>;
      if (error && error.status === 401) {
        errorContent = <React.Fragment>
          <strong>{ failedNotificationsTitle }</strong>
          <div>{ failedNotificationsText }</div>
          <a { ...sso.login }>{ failedNotificationsLink }</a>
        </React.Fragment>;
      }
      return (
        <li className={ classes }>
          { errorContent }
        </li>
      );
    }

    const {
      messages: { noNotificationsTitle, noNotificationsText }
    } = this.props;

    const classes = 'notifications-list-empty notifications-alert';

    return (
      <li className={ classes }>
        <strong>{ noNotificationsTitle }</strong>
        <div className='no-notifications-text'>{ noNotificationsText }</div>
      </li>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 *
 */

NotificationsEmpty.propTypes = {
  /** Used for sign on link when there is 401 error */
  sso: shapes.sso.isRequired,
  /** Notification strings with translations */
  messages: shapes.messages.isRequired,
  /** Provides error code */
  error: PropTypes.object
};

export default NotificationsEmpty;
